import { FormikProps, useFormik } from 'formik';
import { IAddress, IAddressRequestPayload } from 'shared/interfaces/IAddress';
import { capitalizeFirstLetter } from 'shared/utils/common';
import * as yup from 'yup';

type FormProps = {
  data: IAddress | null;
  // type: string;
  onSubmit: (values: IAddressRequestPayload) => void;
};

export const useLocationForm = ({ data, onSubmit }: FormProps) => {
  console.log(
    'initial address type',
    data && data.attributes.address_type
      ? data.attributes.address_type === null
        ? ''
        : data.attributes.address_type
      : '',
  );

  const initialValues: IAddressRequestPayload = {
    location_name: data && data.attributes.location_name ? data.attributes.location_name : '',
    contact_country_code: data && data.attributes.contact_country_code ? data.attributes.contact_country_code : '',
    address1: data && data.attributes.address1 ? data.attributes.address1 : '',
    address2: data && data.attributes.address2 ? data.attributes.address2 : '',
    state_code: data && data.attributes.state_code ? data.attributes.state_code : '',
    country_code: data && data.attributes.country_code ? data.attributes.country_code : 'US',
    city_suburb: data && data.attributes.city_suburb ? data.attributes.city_suburb : '',
    zip_code: data && data.attributes.zip_code ? data.attributes.zip_code : '',
    // type: data && data.attributes.type ? data.attributes.type : type === 'general' ? 'Work' : 'Personal',
    // address_type:
    //   data && data.attributes.address_type
    //     ? // ? capitalizeFirstLetter(data.attributes.address_type)
    //       data.attributes.address_type
    //     : type === 'general'
    //     ? 'Postal'
    //     : 'Postal',
    address_type:
      data && data.attributes.address_type
        ? data.attributes.address_type === null
          ? ''
          : data.attributes.address_type
        : '',
  };

  const validationScheme: yup.SchemaOf<IAddressRequestPayload> = yup.object({
    type: yup.string().notRequired(),
    location_name: yup.string().notRequired(),
    contact_country_code: yup.string().notRequired(),
    address1: yup.string().notRequired(),
    address2: yup.string().notRequired(),
    city_suburb: yup.string().required('City is required'),
    state_code: yup.string(),
    country_code: yup.string().required('Country is required'),
    zip_code: yup.string().notRequired(),
    //address_type can be null
    address_type: yup.string().notRequired().nullable(),
  });

  const form: FormikProps<IAddressRequestPayload> = useFormik({
    initialValues,
    validationSchema: validationScheme,
    // validateOnBlur: true,
    onSubmit: (values, { resetForm }) => {
      onSubmit(values);
      resetForm();
    },
    enableReinitialize: true,
  });

  return {
    form,
  };
};
